import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "hotel-facility" }
const _hoisted_2 = { class: "hotel-facility__facilities" }
const _hoisted_3 = ["textContent"]

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import IconInfoHeader from '@lmt-rpb/Molecules/HotelFacilitiesTeaser/internals/IconInfoHeader.vue';
import { getHotelFacilityIcon } from '@lmt-rpb/Molecules/HotelFacilitiesTeaser/helpers';
import type { Attribute } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';

interface Props {
	attribute: Attribute,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HotelFacility',
  props: {
    attribute: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IconInfoHeader, {
      class: "hotel-facility__icon",
      icon: _unref(getHotelFacilityIcon)(_ctx.attribute.Name),
      title: _ctx.attribute.Name,
      size: "medium"
    }, null, 8 /* PROPS */, ["icon", "title"]),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attribute.Attributes, (facility) => {
        return (_openBlock(), _createElementBlock("li", {
          key: facility.Code,
          class: "hotel-facility__facility"
        }, [
          _createVNode(BaseIcon, {
            class: "hotel-facility__facility-icon",
            width: "15",
            height: "15",
            name: "check"
          }),
          _createElementVNode("span", {
            class: "hotel-facility__facility-text",
            textContent: _toDisplayString(facility.Name)
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})